// extracted by mini-css-extract-plugin
export default {"formGrid":"formGrid_formGrid__mq05q","formGrid__item":"formGrid_formGrid__item__BhdFB","formGrid__item_footer":"formGrid_formGrid__item_footer__RgaS0"};